import { Helmet } from 'react-helmet-async'
import { useLanguage } from '../../hooks/useLanguage'
import Navbar from "../../components/Navbar"
import Hero from "../../components/Hero"
import Bento from "../../components/Bento"
import StackMarquee from "../../components/StackMarquee"
import Process from "../../components/Process"
import About from "../../components/About"
import Faq from "../../components/Faq"
import Contact from "../../components/Contact"
import Footer from "../../components/Footer"

export default function Home() {
  const { language, t } = useLanguage()
  const isEnglish = language === 'en'

  const { title, description, htmlLang } = t.meta
  const url = isEnglish ? 'https://gmstech.dev/en' : 'https://gmstech.dev/'
  const ogLocale = isEnglish ? 'en_US' : 'pt_BR'

  return (
    <div className="w-full bg-white text-gms-ink">
      <Helmet>
        <html lang={htmlLang} />
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:locale" content={ogLocale} />
        <meta property="og:locale:alternate" content={isEnglish ? 'pt_BR' : 'en_US'} />
        <meta property="og:site_name" content="GMS Tech" />
        <meta property="og:image" content="https://gmstech.dev/og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content={title} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="https://gmstech.dev/og-image.png" />
        <link rel="alternate" hrefLang="pt-BR" href="https://gmstech.dev/" />
        <link rel="alternate" hrefLang="en" href="https://gmstech.dev/en" />
        <link rel="alternate" hrefLang="x-default" href="https://gmstech.dev/" />
      </Helmet>
      <Navbar />
      <main>
        <Hero />
        <Bento />
        <StackMarquee />
        <Process />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}
